/* unplugin-vue-components disabled */import script from "./ItemList.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemList.vue?vue&type=script&setup=true&lang=js"

import "./ItemList.vue?vue&type=style&index=0&id=bf101fcc&lang=stylus"

const __exports__ = script;

export default __exports__